import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthApi } from '../../services/auth-api/auth-api.service';
import { PermissionsService } from '../../services/permissions/permissions.service';
import { ToastNotificationsManagerService } from '../../services/toast-notifications-manager/toast-notifications-manager.service';
import { AddToastNotif } from '../../types/toast-notification.type';

export const canActivateRouteGuard: CanActivateFn = async (
  currentRoute: ActivatedRouteSnapshot,
  currentRouterState: RouterStateSnapshot,
) => {
  const authApi = inject(AuthApi);
  const router = inject(Router);
  const permissionsService = inject(PermissionsService);

  // check for sessionStorage set by AuthApi Service
  authApi.setPermissions();
  const requiredPermission = currentRoute.data.requiredPermission;
  /*Permission service taking permission string*/
  permissionsService.hasPermission(requiredPermission);
  const src = currentRouterState.url.slice(1);
  /** cookie and session storage info should be same session info same as AuthToken */
  if (authApi.isLoggedIn()) {
    if (requiredPermission) {
      /* checks for permissions in passed string or array of strings */
      if (permissionsService.hasPermission(requiredPermission) === false) {
        unauthorizedMessage(
          'You do not have permission to view this page. Please contact your account administrator for any assistance',
        );
        return router.parseUrl('/');
      }
      return true;
    }
    return true;
  } else {
    authApi.sourceUrl = src;
    // TODO: user refresh token to attempt new JSESSIONID cookie and access_token SessionStorage
    // TODO: if login is necessary, then return to the same currentRoute and currentRouteState which should be possible
    // return this.router.navigate(["login"], state: { currentRoute: this.currentRoute, currentRouterState: this.currentRouterState })
    // NOTE: we do not delete auth so the user can use the back button just in case
    // return false will abort current navigation so instead we can navigate to /login
    // return this.router.navigate(["login"], { state: { msg: msg } });

    // TODO: If isLoggedIn is falsey then delete cookie too
    unauthorizedMessage('Not authorized. Please log in to continue.');
    return router.parseUrl('/login');
  }
};

/**
 * unauthorizedMessage is triggered when can active returns false
 * and presents the passed in error message to the user
 * @param msg
 */
const unauthorizedMessage = (msg?: string) => {
  const toastNotif = inject(ToastNotificationsManagerService);

  const notification: AddToastNotif = {
    type: 'error',
    content: msg ?? 'You do not have permissions to view this page',
  };
  toastNotif.addNew(notification);
};
